<div class="dropdown-item border-radius-sm medium-title-text p-xs color-black" data-testid="dropdown-item">
    <ng-content></ng-content>
</div>